import { ReactElement } from 'react';

import { IconProps } from '@components/icons';
import { IconInfo } from '@components/icons/info';
import { InfoBox } from '@components/info-box';
import { getScopedTranslate, useScopedTranslate } from '@locale/translate';

import { InfoBoxVariant } from '../common';

export const functionLabel = (functionName: keyof (typeof locale)['en'] | undefined) => {
  const { t } = getScopedTranslate(locale);
  if (!functionName) return '';
  return t(functionName);
};

type InfoType = 'dateMonthFutureDateInfo';

const TYPE_TO_VARIANT: Record<InfoType, InfoBoxVariant> = {
  dateMonthFutureDateInfo: 'blue',
};

const TYPE_TO_TEXT: Record<InfoType, keyof typeof locale.en> = {
  dateMonthFutureDateInfo: 'infoDateMonthFutureDate',
};

const TYPE_TO_ICON: Record<InfoType, ReactElement<IconProps>> = {
  dateMonthFutureDateInfo: <IconInfo />,
};

export const FormatterInfoBox = ({
  infoType,
  children,
}: {
  infoType: InfoType;
  children?: ReactElement;
}) => {
  const { t } = useScopedTranslate(locale);
  const variant = TYPE_TO_VARIANT[infoType];
  const text = t(TYPE_TO_TEXT[infoType]);
  const icon = TYPE_TO_ICON[infoType];
  return <InfoBox variant={variant} text={text} icon={icon} children={children} />;
};

const locale = {
  en: {
    first_item_of_array: 'First item of array',
    last_item_of_array: 'Last item of array',
    random_item_of_array: 'Random item of array',
    length_of_array: 'Length of array',
    digest_sha256_file: 'File digest sha256',
    file_extension: 'File extension',
    date_month_future_date: 'Next occurrence',
    infoDateMonthFutureDate:
      'Get the next occurrence for the same month and day of the selected date. If the date is the 29th of February and it is not a leap year then the 1st of March will be used instead.',
  },
};
